import {
  useStaticQuery,
  graphql
} from 'gatsby';

const allResourceCenterPost = graphql `
  query {
    allWpResourceCenterPost {
      nodes {
        id
        title
        slug
        uri
        content
        tags {
          nodes {
            name
            slug
          }
        }
        categories {
          nodes {
            slug
            name
          }
        }
        featuredImage {
          node {
            altText
            sourceUrl
            srcSet
          }
        }
        template {
          ...on WpTemplate_ResourceCenterArticle {
            templateName
            resourceCenterPost {
              resourceCenterPostAverageRating
            }
          }
        }
        seo {
          readingTime
        }
        language {
          code
          name
          locale
          slug
        }
        translations {
          title
          excerpt
          uri
          slug
          featuredImage {
            node {
              altText
              srcSet
              sourceUrl
            }
          }
          seo {
            readingTime
          }
          tags {
            nodes {
              name
              slug
            }
          }
          language {
            slug
            code
            locale
            name
          }
          template {
            ...on WpTemplate_ResourceCenterArticle {
              resourceCenterPost {
                resourceCenterPostAverageRating
              }
            }
          }
        }
      }
    }
  }
`;

const useAllResourceCenterPosts = () => {
  const {
    allWpResourceCenterPost: {
      nodes
    },
  } = useStaticQuery(allResourceCenterPost);

  return nodes;
};

export default useAllResourceCenterPosts;
